module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loading":"Loading ...","results":"{n} result | {n} results"}}')
  delete Component.options._Ctor
}
